import { FiLayers } from 'react-icons/fi';
import moment from 'moment';
import { useSelector, useDispatch } from 'react-redux';
import {
  getDashboardProjectList,
  getDashboardTaskList,
} from '../../../redux/MainAction';
import { useState } from 'react';
import { IoMdRefresh } from 'react-icons/io';

const ProjectsCard = ({}) => {
  const dispatch = useDispatch();
  const [firstRefresh, setFirstRefresh] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const Project = useSelector((state) => state.Webtracker.dashboardProjectList);
  const task = useSelector((state) => state.Webtracker.dashboardTaskList);

  const convertSeconds = (seconds) => {
    const isNegative = seconds < 0;
    const duration = moment.duration(Math.abs(seconds), 'seconds');

    const days = Math.floor(duration.asDays());
    const hours = duration.hours();
    const minutes = duration.minutes();
    const secs = duration.seconds();

    const parts = [];
    if (days) parts.push(`${days}d`);
    if (hours || days) parts.push(`${hours}h`);
    parts.push(`${minutes}m`);
    if (!days) parts.push(`${secs}s`);

    return `${isNegative ? '-' : ''}${parts.join(' : ')}`;
  };

  async function fetchDashboardData(isFirstRefresh) {
    setIsLoading(true);
    if (isFirstRefresh) setFirstRefresh(true);

    await dispatch(getDashboardProjectList());
    await dispatch(getDashboardTaskList());

    setIsLoading(false);
  }

  return (
    <div className="col-6">
      <div className="card m-b-20 enhanced-card">
        <div className="border_class d-flex align-items-center justify-content-between">
          <h5 className="dash-card-title font-20 ml-3">
            Projects & Task Details
          </h5>

          {firstRefresh ? (
            <IoMdRefresh
              onClick={fetchDashboardData}
              title="Refresh Data"
              className="dashboard_reload_icon"
            />
          ) : null}
        </div>
        <div className="card-body dash_cards act_card2">
          <ul className="nav nav-tabs dash-nav-tabs-custom px-3" role="tablist">
            <li className="nav-item">
              <a
                className="nav-link active"
                data-toggle="tab"
                href="#home1"
                role="tab"
              >
                <span className="d-none d-md-block">Projects</span>
                <span className="d-block d-md-none">
                  <i className="mdi mdi-home-variant h5"></i>
                </span>
              </a>
            </li>
            <li className="nav-item">
              <a
                className="nav-link"
                data-toggle="tab"
                href="#project_1"
                role="tab"
              >
                <span className="d-none d-md-block">Tasks</span>
                <span className="d-block d-md-none">
                  <i className="mdi mdi-account h5"></i>
                </span>
              </a>
            </li>
          </ul>

          {isLoading ? (
            <div className="d-flex align-items-center justify-content-center h-100">
              <div className="spinner-border text-primary " role="status"></div>
            </div>
          ) : firstRefresh ? (
            <div className="tab-content mb-4">
              <div
                className="tab-pane active px-3 pb-3 pt-0"
                id="home1"
                role="tabpanel"
              >
                <div className="table-responsive dash-tdAct">
                  <table className="table table-vertical mb-0">
                    <tbody>
                      {Project?.count > 0 ? (
                        Project?.rows?.map((prj, idx) => (
                          <tr>
                            <td>
                              <span className="text-muted mr-1">
                                <FiLayers className="font-20 dash-text-primary" />
                              </span>{' '}
                              {prj?.name}
                            </td>
                            <td>
                              <span
                                style={{ float: 'right' }}
                                className="dash_time_border2"
                              >
                                {convertSeconds(prj?.totalTime)}
                              </span>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="2">
                            <div className="empty-state">
                              <i className="mdi mdi-format-list-bulleted font-40"></i>
                              <span className="font-14">
                                Project and time tracked on them will appear
                                here when you start tracking
                              </span>
                            </div>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>

              <div
                className="tab-pane px-3 pb-3 pt-0"
                id="project_1"
                role="tabpanel"
              >
                <div className="table-responsive dash-tdAct">
                  <table className="table table-vertical mb-0">
                    <tbody>
                      {task?.count > 0 ? (
                        task?.rows?.map((prj, idx) => (
                          <tr>
                            <td>
                              <span className="text-muted mr-1">
                                <FiLayers />
                              </span>{' '}
                              {prj?.name}
                            </td>
                            <td>
                              <span
                                style={{ float: 'right' }}
                                className="time_border2"
                              >
                                {convertSeconds(prj?.totalTime)}
                              </span>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="2">
                            <div className="empty-state">
                              <i className="mdi mdi-format-list-bulleted font-40"></i>
                              <span className="font-14">
                                Tasks and time tracked on them will appear here
                                when you start tracking
                              </span>
                            </div>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>

              <div
                className="tab-pane px-3 pb-3 pt-0"
                id="apps_2"
                role="tabpanel"
              >
                <div className="table-responsive dash-tdAct">
                  <table className="table table-vertical mb-0">
                    <tbody>
                      {
                        <tr>
                          <td colSpan="2">
                            <div className="empty-state">
                              <i className="mdi mdi-format-list-bulleted font-40"></i>
                              <span className="font-14">
                                Apps and time tracked on them will appear here
                                when you start tracking
                              </span>
                            </div>
                          </td>
                        </tr>
                      }
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          ) : (
            <div className="d-flex align-items-center justify-content-center h-100">
              <button
                className="btn btn-primary font-14"
                onClick={() => fetchDashboardData(true)}
              >
                Load Data
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProjectsCard;
